import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import username from 'flarum/common/helpers/username';
import icon from 'flarum/common/helpers/icon';

/**
 * Replacement profile page shown between blocked pairs.
 *
 * - I blocked them  → status + what blocking means + Unblock button
 * - They blocked me → status + what blocking means (no actions)
 */
export default class BlockedProfilePanel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }

  view() {
    const user = this.attrs.user;
    // ghostIgnored (FoF's `ignored` attribute) updates optimistically on
    // click, ghostBlocked arrives with the server response — check both so
    // the panel state is correct immediately after blocking.
    const blockedByMe = !!(user.ghostBlocked() || user.ghostIgnored());

    return (
      <div className="UserPage GhostBlock-page">
        <div className="Hero UserHero GhostBlock-hero">
          <div className="container">
            <div className="containerNarrow">
              <div className="GhostBlock-avatar">{icon('fas fa-ghost')}</div>
              <h2 className="Hero-title GhostBlock-username">{username(user)}</h2>
              <div className={'GhostBlock-status ' + (blockedByMe ? 'GhostBlock-status--byMe' : 'GhostBlock-status--me')}>
                {icon(blockedByMe ? 'fas fa-ban' : 'fas fa-user-slash')}{' '}
                {blockedByMe
                  ? app.translator.trans('happydigital-ghost-block.forum.profile.blocked_by_you')
                  : app.translator.trans('happydigital-ghost-block.forum.profile.blocked_you')}
              </div>
            </div>
          </div>
        </div>

        <div className="container GhostBlock-body">
          <div className="containerNarrow">
            <div className="GhostBlock-card">
              <h3 className="GhostBlock-cardTitle">
                {app.translator.trans('happydigital-ghost-block.forum.profile.effects_title')}
              </h3>
              <ul className="GhostBlock-effects">
                <li>
                  {icon('fas fa-comments')}
                  <span>{app.translator.trans('happydigital-ghost-block.forum.profile.effect_content')}</span>
                </li>
                <li>
                  {icon('fas fa-eye-slash')}
                  <span>{app.translator.trans('happydigital-ghost-block.forum.profile.effect_mutual')}</span>
                </li>
                <li>
                  {icon('fas fa-id-card')}
                  <span>{app.translator.trans('happydigital-ghost-block.forum.profile.effect_profile')}</span>
                </li>
              </ul>

              <p className="GhostBlock-note">
                {blockedByMe
                  ? app.translator.trans('happydigital-ghost-block.forum.profile.unblock_note')
                  : app.translator.trans('happydigital-ghost-block.forum.profile.blocked_you_note')}
              </p>

              {blockedByMe && (
                <div className="GhostBlock-actions">
                  <Button
                    className="Button Button--primary GhostBlock-unblockButton"
                    icon="fas fa-user-check"
                    loading={this.loading}
                    onclick={() => this.unblock(user)}
                  >
                    {app.translator.trans('happydigital-ghost-block.forum.profile.unblock_button')}
                  </Button>
                  <LinkButton className="Button Button--link" href={app.route('user.ghostBlocked')} icon="fas fa-list">
                    {app.translator.trans('happydigital-ghost-block.forum.profile.blocked_list_link')}
                  </LinkButton>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  unblock(user) {
    this.loading = true;

    // FoF Ignore's backend listener persists the `ignored` attribute;
    // the global save wrapper in index.js reloads the page afterwards.
    user
      .save({ ignored: false })
      .catch(() => {})
      .then(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
